import client from './client';

export default {
  create({ email }) {
    return client.post('/password_resets')
      .send(email)
      .end();
  },

  update({ token, password, passwordConfirmation }) {
    return client.patch(`/password_resets/${token}`)
      .send({
        password: password,
        passwordConfirmation: passwordConfirmation
      })
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/passwordResetAPI.js